import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static values = { title: String, html: { default: false, type: Boolean } };

  connect() {
    tippy(this.element, {
      theme: "light-border tooltip",
      touch: ["hold", 500],
      allowHTML: this.htmlValue,
      offset: [0, 12],
      interactive: true,
      animation: "scale",
      content: () => this.titleValue
    });
  }
}
